import { memo } from "react";
import { useIntersectionObserver } from "usehooks-ts";
import type { TPage } from "@/shared/services/pages/types";
import { useSlidesLibraryStoreShallow } from "@modules/slides-library/shared";

export const StoryCard = memo(({ story }: { story: TPage }) => {
  const setImportStoriesSelectedStory = useSlidesLibraryStoreShallow(
    (s) => s.setImportStoriesSelectedStory,
  );
  const { ref, isIntersecting } = useIntersectionObserver({ threshold: 0.1 });

  const settings = story.settings as Record<string, string>;
  const title = settings?.title || "Untitled";

  const handleSelect = () => {
    setImportStoriesSelectedStory(story._id, title, settings?.contentPointer || "");
  };

  return (
    // biome-ignore lint/a11y/useSemanticElements: <iframe> child is not valid inside a <button> per HTML spec
    <div
      ref={ref}
      role="button"
      tabIndex={0}
      aria-label={`Open story: ${title}`}
      className="tw-group tw-cursor-pointer tw-rounded-xl tw-p-2 tw-transition-colors hover:tw-bg-blue-50 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-blue-200"
      onClick={handleSelect}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleSelect();
        }
      }}
    >
      <div className="tw-h-[191.5px] tw-w-[340px] tw-overflow-hidden tw-rounded-lg tw-outline tw-outline-1 tw-outline-blue-200 !tw-outline-offset-0 tw-shadow-sm tw-bg-white">
        {isIntersecting && story.previewUrl && (
          <iframe
            src={`${story.previewUrl}?preview=false&analytics=false&progressBar=false&engagementBar=false&loader=false&static=true&selected-slides=1`}
            title={title}
            className="tw-pointer-events-none tw-h-full tw-w-full tw-border-none"
            style={{
              width: "400%",
              height: "400%",
              transform: "scale(0.25)",
              transformOrigin: "0 0",
            }}
          />
        )}
      </div>
      <div className="tw-mt-3">
        <span className="tw-block tw-truncate tw-font-sans tw-text-sm tw-font-normal tw-text-blue">
          {title}
        </span>
      </div>
    </div>
  );
});
StoryCard.displayName = "StoryCard";
